"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.title = title;
function title(coilType) {
    switch (coilType) {
        case "fluid-cooling":
            return "Fluid coil, wet";
        case "fluid-heating":
            return "Fluid coil, dry";
        case "dx":
            return "DX coil";
        case "condenser":
            return "Condensor coil";
        case "steam":
            return "Steam coil";
        default:
            throw new Error("Unknown coil type");
    }
}
//# sourceMappingURL=title.js.map